
/* Dallas Sucks Coffee Company announcement rotator v1
   Edit the text/url pairs below for future promos. */
(function(){
  var dsccTickerItems = [
    { text: "Fresh roast drops are brewing. Stay petty.", url: "/pages/beans" },
    { text: "Petty Cash is loading. Billboard chaos requires funding.", url: "/pages/petty-cash" },
    { text: "Choose your side. Philly roast supremacy starts here.", url: "/pages/beans" },
    { text: "Got tasting notes? Drop them on the book.", url: "/pages/tasting-notes" }
  ];

  var dsccTickerIndex = 0;

  function rotateDSCCTicker(){
    var el = document.getElementById("dscc-announcement-link");
    if(!el || !dsccTickerItems.length) return;
    var item = dsccTickerItems[dsccTickerIndex];
    el.textContent = item.text;
    el.setAttribute("href", item.url || "#");
    dsccTickerIndex = (dsccTickerIndex + 1) % dsccTickerItems.length;
  }

  document.addEventListener("DOMContentLoaded", function(){
    rotateDSCCTicker();
    window.setInterval(rotateDSCCTicker, 5000);
  });
})();
